<script>
import lazyLoadComponent from '@router/lazyload-component'

const initData = () => {
	return {
		fullName: '',
		gender: 'male',
		phoneCode: '+886',
		phoneNumber: '',
		email: '',
		note: ''
	}
}

export default {
	components: {
		CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
	},
	props: {
		/**
		 * @description 會員資訊
		 */
		memberInfo: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			submitData: Object.assign({}, initData()),
			checked: false
		}
	},
	computed: {
		submitRules() {
			const isTaiwan = this.submitData.phoneCode === '+886'
			const isGuest = this.$store.state.merchant.cached.guest === this.memberInfo.id
			// const isTaiwan = true
			return {
				fullName: [{
					required: true,
					message: '請輸入姓名'
				}],
				phoneNumber: [{
					required: true,
					message: '請填寫手機號碼',
					trigger: 'blur',
				},
				{
					pattern: isGuest ? '' : isTaiwan ? /^09\d{8}$/ : '',
					message: '格式請符合 09XXXXXXXX',
					trigger: 'blur',
				},
				],
				gender: [{
					required: true,
					message: '請選擇性別',
					// trigger: 'change',
				}],
				email: [{
					type: 'email',
					message: '請輸入正確的 Email 格式',
					trigger: 'blur',
				},
				],
			}
		}
	},
	watch: {
		submitData: {
			handler(nvl) {
				this.$emit('updatePayPersonInfo', nvl)
			},
			deep: true
		},
		checked(nvl) {
			if (nvl) {
				this.$set(this.submitData, 'gender', this.memberInfo.gender)
				this.$set(this.submitData, 'email', this.memberInfo.email || '')
				this.$set(this.submitData, 'fullName', this.memberInfo.fullName)
				this.$set(this.submitData, 'phoneCode', this.memberInfo.phoneCode)
				this.$set(this.submitData, 'phoneNumber', this.memberInfo.phoneNumber)
			}
		}
	},
	created() {
	},
	mounted() {
		this.$nextTick(() => {
			// 如果已經有會員資料，則幫使用者checked
			if (this.memberInfo.fullName && this.memberInfo.phoneCode) {
				this.checked = true
			}
		})
	},
	methods: {
		validate() {
			return this.$refs.form.validate()
		},
	},
}
</script>
<template>
	<div :class="$style.reserveformSection">
		<div class="reserveformSection__right__content">
			<el-form ref="form" :model="submitData" :rules="submitRules" label-position="top"
				class="el-form-item--normal-margin el-form-item--white-bg">
				<el-row :gutter="20" :class="$style.reserveForm">
					<el-col :span="24">
						<el-form-item>
							<span :class="$style['reserveForm__user']">使用人</span><el-checkbox
								v-model="checked">使用人同客戶</el-checkbox>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="fullName" label="姓名" class="el-form-item--normal-margin">
							<el-input v-model="submitData.fullName" placeholder="請輸入姓名" class="is-border"> </el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item class="el-form-item--normal-margin gender-box" prop="gender">
							<el-radio-group v-model="submitData.gender" class="no-bg-radio-group">
								<el-radio label="male">先生</el-radio>
								<el-radio label="female">小姐</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>

					<el-col :span="24">
						<el-form-item prop="phoneNumber" label="電話" class="el-form-item--normal-margin">
							<el-input v-model.trim="submitData.phoneNumber" placeholder="請輸入手機號碼">
								<CountryCodePicker slot="prepend" v-model="submitData.phoneCode" />
							</el-input>
						</el-form-item>
					</el-col>

					<el-col :span="24">
						<el-form-item label="Email" prop="email">
							<el-input v-model="submitData.email" placeholder="Email"></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="24">
						<el-form-item label="使用人備註">
							<el-input v-model="submitData.note" type="textarea" :rows="10"
								class="bg-white is-border is-round" />
						</el-form-item>
					</el-col>

				</el-row>
			</el-form>
		</div>
	</div>
</template>
<style lang="scss" module>

.reserveformSection {

	:global {
		.reserveformSection {
			&__right {
				position: relative;
				width: 43%;
				height: calc(100vh);
				overflow: hidden;

				&__content {
					z-index: 10;
					height: calc(100vh - 60px);
					overflow: auto;
					padding: 60px;
					position: relative;
					background-color: $color-line;

					@include max-lg {
						padding: 20px;
					}
				}
			}
		}
	}
}

.reserveForm {
	&__user {
		color: $color-secondary;
		font-size: 16px;
		margin-right: 12px;
		display: inline-block;
	}
}
</style>